import React, { useEffect, createElement } from 'react';
import { motion } from 'framer-motion';
import { Icon } from '../ui/Icon';
export function Testimonials() {
  useEffect(() => {
    // Load Wistia scripts
    const script1 = document.createElement('script');
    script1.src = 'https://fast.wistia.com/player.js';
    script1.async = true;
    document.head.appendChild(script1);
    const script2 = document.createElement('script');
    script2.src = 'https://fast.wistia.com/embed/odv1s0ojhk.js';
    script2.async = true;
    script2.type = 'module';
    document.head.appendChild(script2);
    // Add Wistia styles
    const style = document.createElement('style');
    style.textContent = `
      wistia-player[media-id='odv1s0ojhk']:not(:defined) { 
        background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/odv1s0ojhk/swatch'); 
        display: block; 
        filter: blur(5px); 
        padding-top: 56.6%; 
      }
    `;
    document.head.appendChild(style);
    return () => {
      // Cleanup only if elements still exist
      if (document.head.contains(script1)) document.head.removeChild(script1);
      if (document.head.contains(script2)) document.head.removeChild(script2);
      if (document.head.contains(style)) document.head.removeChild(style);
    };
  }, []);
  return <section className="py-20 bg-gradient-to-b from-gray-50 to-white relative overflow-hidden" data-id="element-224">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-yellow-500 to-transparent opacity-50" data-id="element-225" />

      <div className="max-w-6xl mx-auto px-6" data-id="element-226">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-227">
          <div className="inline-flex items-center gap-2 bg-black text-yellow-400 px-4 py-2 rounded-full text-sm font-bold uppercase tracking-wider mb-4" data-id="element-228">
            <Icon name="users" size={18} data-id="element-229" />
            Testimonios
          </div>
          <h2 className="text-4xl md:text-5xl font-extrabold text-black mb-4" data-id="element-230">
            Resultados Reales de Estudiantes Reales
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto" data-id="element-231">
            Escucha directamente de quienes ya están aplicando el sistema y
            generando resultados
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="max-w-5xl mx-auto" data-id="element-232">
          <div className="relative rounded-2xl overflow-hidden shadow-2xl border-2 border-gray-200 bg-black" data-id="element-233">
            <wistia-player media-id="odv1s0ojhk" aspect="1.7666666666666666" className="w-full" data-id="element-234" />
          </div>
        </motion.div>

        {/* Social proof stats */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-235">
          <div className="text-center" data-id="element-236">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-yellow-400 to-yellow-600 rounded-full mb-4" data-id="element-237">
              <Icon name="star" size={32} className="text-black" data-id="element-238" />
            </div>
            <div className="text-3xl font-extrabold text-black mb-2" data-id="element-239">
              $100M+
            </div>
            <div className="text-gray-600 font-medium" data-id="element-240">En Ventas Generadas</div>
          </div>

          <div className="text-center" data-id="element-241">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-yellow-400 to-yellow-600 rounded-full mb-4" data-id="element-242">
              <Icon name="users" size={32} className="text-black" data-id="element-243" />
            </div>
            <div className="text-3xl font-extrabold text-black mb-2" data-id="element-244">
              1,000+
            </div>
            <div className="text-gray-600 font-medium" data-id="element-245">Estudiantes Activos</div>
          </div>

          <div className="text-center" data-id="element-246">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-yellow-400 to-yellow-600 rounded-full mb-4" data-id="element-247">
              <Icon name="rocket" size={32} className="text-black" data-id="element-248" />
            </div>
            <div className="text-3xl font-extrabold text-black mb-2" data-id="element-249">
              7 Días
            </div>
            <div className="text-gray-600 font-medium" data-id="element-250">Primeros Resultados</div>
          </div>
        </motion.div>
      </div>
    </section>;
}